import { gql } from "@apollo/client";

/**
 * What a dashboard card needs to deep-link into a node's contact tab: the
 * ancestor path (tree URL) and write access (the "Assign" link). Same fields
 * as InstalledBaseNodeEventContext, so on the asset dashboard this resolves
 * from the cache.
 */
export const InstalledBaseNodeContactLinkContext = gql`
    query InstalledBaseNodeContactLinkContext($id: ID!) {
        installedBaseNode(id: $id) {
            id
            pathNodes {
                id
            }
            access {
                id
                write
            }
        }
    }
`;
